import styled from "styled-components";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { ModalLabel } from "./TargetContainer";
import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import RadioBtn from "../../../../Button/RadioBtn";
import CalendarModalBtn from "../../../../Button/CalendarModalBtn";
import { Row } from "./CommentModal";

interface CommentDueDateProps {
  hasDueDate: boolean;
  setHasDueDate: Dispatch<SetStateAction<boolean>>;
  dueDate: string;
  setDuedate: Dispatch<SetStateAction<string>>;
  dueDateTime: OptionType;
  setDueDateTime: Dispatch<SetStateAction<OptionType>>;
  type?: string;
}

export default function CommentDueDate({
  hasDueDate,
  setHasDueDate,
  dueDate,
  setDuedate,
  dueDateTime,
  setDueDateTime,
  type,
}: CommentDueDateProps) {
  const [hourOptionList, setHourOptionList] = useState<OptionType[]>([]);

  useEffect(() => {
    const hourOptionList: OptionType[] = [];
    const hourList = Array.from({ length: 24 }, (_, i) => i);

    for (let i = 0; i < hourList.length; i++) {
      const e = hourList[i];
      hourOptionList.push({
        value: e < 10 ? `0${e}` : `${e}`,
        label: e < 10 ? `0${e}시` : `${e}시`,
      });
    }

    setHourOptionList(hourOptionList);
  }, []);

  return (
    <>
      <ModalLabel>해결 기한</ModalLabel>

      <Row style={{ gap: 10 }}>
        <RadioBtnContainer>
          <RadioBtn
            label="설정"
            check={hasDueDate}
            clickEvent={() => setHasDueDate(true)}
            noTooltip
            sHeight={38}
            disabled={type === "view"}
          />
        </RadioBtnContainer>

        <CalendarModalBtn
          calendar={{
            value: dueDate,
            initValue: dueDate,
            disabled: !hasDueDate,
          }}
          modal={{
            changeEvent: (date) => setDuedate(date),
          }}
        />

        <DropDown
          setDropDownValue={setDueDateTime}
          dropdownValue={dueDateTime}
          optionList={hourOptionList}
          boxWidth={120}
          isDisabled={!hasDueDate}
        />
      </Row>

      <RadioBtn
        label="해당 없음"
        check={!hasDueDate}
        clickEvent={() => setHasDueDate(false)}
        noTooltip
        sHeight={38}
        disabled={type === "view"}
      />
    </>
  );
}

const RadioBtnContainer = styled.div`
  width: 106px;
  height: 38px;
  display: flex;
  align-items: center;
`;
